import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient, ApiResponseError } from "~/utils";

import { ApiManagersRoleplayingConditionTemplateEditResponseType } from "~/domains";

type ParamsType = {
  id: string;
};

const request = async ({
  id,
}: ParamsType): Promise<ApiManagersRoleplayingConditionTemplateEditResponseType> => {
  const response =
    await new ApiClient().get<ApiManagersRoleplayingConditionTemplateEditResponseType>(
      `/api/managers/roleplaying_condition_templates/${id}/edit`,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  id: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisManagersRoleplayingConditionTemplatesEdit = ({
  id,
  config = {},
}: PropsType): UseQueryResult<ApiManagersRoleplayingConditionTemplateEditResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisManagersRoleplayingConditionTemplatesEdit", id],
    cacheTime: 0,
    queryFn: () => request({ id }),
    useErrorBoundary: (error) => {
      return error instanceof ApiResponseError && error.status >= 500;
    },
  });
};
